import MTinderInnerCarousel from './MTinderInnerCarousel';
import React from 'react';
type Props = {
    images?: any[];
};
export default function MTinderCarousel({ images }: Props) {
    return (
        <React.Fragment>
            {images && images.length > 0 && (
                <div>
                    {images[0].images && (
                        <div key={images[0].name}>
                            <MTinderInnerCarousel images={images[0].images} />
                            {images[0].text && images[0].name && (
                                <div className="m-tinder-description">
                                    <div className="m-tinder-description__name">{images[0].name}</div>
                                    <div className="m-tinder-description__text">{images[0].text}</div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            )}
        </React.Fragment>
    );
}
